import LazyIcon from './LazyIcon';
export * from './LazyIcon';
export * from './utils';
export default LazyIcon;
